import { useTranslations } from 'languages';
import { TagWikiLayout } from 'modules/pages/TagWikiPersonalPage';
import { useRouter } from 'next/router';
import { FC } from 'react';
import { TagWikiMainPropsType } from 'types/pages/TagWikiPersonal';
import { siteText } from '../../siteText';

export const SearchForTagWiki: FC<TagWikiMainPropsType> = ({ tagWikiData }) => {
  const t = useTranslations();

  const { locale = '' } = useRouter();

  const {
    slug_en = '',
    slug_ru = '',
    slug_uk = '',
    title_ru = '',
    title_uk = '',
    title_en = '',
  } = { ...tagWikiData[0].seo };

  const tagTitle = locale === 'ru' ? title_ru : locale === 'uk' ? title_uk : title_en;

  const metaTagWiki = {
    title: `${t('metaForSearchTag.titleFirstPart')}${tagTitle} ${t(
      'metaForSearchTag.titleSecondPart'
    )}`,
    description: `${t('metaForSearchTag.description')} ${tagTitle}`,
    keywords: `${tagTitle}, ${tagTitle}${t('metaForSearchTag.keyword')}`,
    slugs: {
      slug_en: `tag_wiki/${slug_en}`,
      slug_ru: `tag_wiki/${slug_ru}`,
      slug_uk: `tag_wiki/${slug_uk}`,
    },
  };

  return (
    <TagWikiLayout
      siteText={siteText}
      metaTagWiki={metaTagWiki}
      tagWikiData={tagWikiData}
    />
  );
};
export default SearchForTagWiki;
